import { useState, Fragment, useRef, useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Helmet } from 'react-helmet';
import "swiper/css/swiper.css";
import "../segurohyundai/seguroHyundai.css"
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faDownload,
    faCar,
    faChevronLeft,
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
/**** Fotos Banner ****/
import Slider1 from "../../images/seguros/Banner Principal 1.webp";
import Slider2 from "../../images/seguros/Banner Principal 2.webp";
import image1 from "../../images/seguros/beneficios.webp";
import image2 from "../../images/seguros/deduciblesA.webp"
/****Fotos beneficios ****/
import deducibleA from "../../images/seguros/iconos-med/Deducibles 320x320 A.webp"
import deducibleB from "../../images/seguros/iconos-med/Deducibles 320x320 B.png"
import deducibleC from "../../images/seguros/iconos-med/Deducibles 320x320 C.png"
import deducibleD from "../../images/seguros/iconos-med/Deducibles 320x320 D.webp"
import beneficioA from "../../images/seguros/iconos-med/icono 320x320 A.png"
import beneficioB from "../../images/seguros/iconos-med/icono 320x320 B.png"
import beneficioC from "../../images/seguros/iconos-med/icono 320x320 C.webp"
import beneficioD from "../../images/seguros/iconos-med/icono 320x320 D.webp"
import beneficioE from "../../images/seguros/iconos-med/icono 320x320 E.png"
import beneficioF from "../../images/seguros/iconos-med/icono 320x320 F.webp"
import beneficioG from "../../images/seguros/iconos-med/icono 320x320 G.webp"
import beneficioH from "../../images/seguros/iconos-med/icono 320x320 H.png"
import beneficioSmallA from "../../images/seguros/iconos-peq/Icono 224x224 A.png"
import beneficioSmallB from "../../images/seguros/iconos-peq/Icono 224x224 B.png"
import beneficioSmallC from "../../images/seguros/iconos-peq/Icono 224x224 C.png"
import beneficioSmallD from "../../images/seguros/iconos-peq/Icono 224x224 D.png"
import beneficioSmallE from "../../images/seguros/iconos-peq/Icono 224x224 E.png"
import beneficioSmallF from "../../images/seguros/iconos-peq/Icono 224x224 F.png"
import beneficioSmallG from "../../images/seguros/iconos-peq/Icono 224x224 G.png"
// import beneficioSmallH from "../../images/seguros/iconos-peq/Icono 224x224 H.png"
import beneficioSmallI from "../../images/seguros/iconos-peq/Icono 224x224 I.png"
import beneficioSmallJ from "../../images/seguros/iconos-peq/Icono 224x224 J.png"
import beneficioSmallK from "../../images/seguros/iconos-peq/Icono 224x224 K.png"
import beneficioSmallL from "../../images/seguros/iconos-peq/Icono 224x224 L.png"
import beneficioSmallM from "../../images/seguros/iconos-peq/Icono 224x224 M.png"
import contactanos from "../../images/seguros/contactos.png"
/****Ficha técnica ****/
import SeguroHyundai from "../../fichas/seguro-hyundai.pdf";
import "./style.css"
import ModalContactoSeguroHyundai from "./ModalContacto";
import Enviar from "../../images/assets/enviar.png";

function InfoSeguroHyundai() {
    const [show, setShow] = useState(false);
    const onChangeMenu = (menu) => {
        switch (menu) {
            case "beneficios":
                document.getElementById("tab-beneficios").className = "color-hover";
                document.getElementById("tab-deducibles").className = "color-normal";
                document.getElementById("beneficios").className = "d-block";
                document.getElementById("deducibles").className = "d-none";
                document.getElementById("img-carrusel").src = Slider1;
                break;

            case "deducibles":
                document.getElementById("tab-beneficios").className = "color-normal";
                document.getElementById("tab-deducibles").className = "color-hover";
                document.getElementById("beneficios").className = "d-none";
                document.getElementById("deducibles").className = "d-block";
                document.getElementById("img-carrusel").src = Slider2;
                break;
            default:
                break;
        }
    };
    
    const imgBanner = useRef(null);
    useEffect(() => {
        if (imgBanner.current) {
            const imgElement = imgBanner.current;
            imgElement.setAttribute('width', imgElement.naturalWidth);
            imgElement.setAttribute('height', imgElement.naturalHeight)
        }
    }, []);

    return (
        <Fragment>
            <Container fluid={true}>
                <Row>
                    <Col md={12} className="px-0" ref={ imgBanner}>
                        <Helmet>
                            <link rel="preload" href={Slider1} as="image" />
                        </Helmet>
                        <div>
                            <img
                                src={Slider1}
                                alt="Beneficios Banner"
                                className="imgBanner-seguros"
                                id="img-carrusel"
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
            <div className="menu-vehiculo sticky-top">
                <Container>
                    <Row className="py-2 py-md-4">
                        <Col xs={2} md={2} className="my-auto d-none d-sm-block">
                            <h1 className="menu-modelo">Hyundai Seguros</h1>
                        </Col>
                        <Col
                            xs={6}
                            md={8}
                            className="my-auto vehiculo-item  px-0"
                        >
                            <ul className="my-auto p-0 m-0">
                                <li
                                    id="tab-beneficios"
                                    onClick={() => onChangeMenu("beneficios")}
                                    className="color-hover"
                                >
                                    Beneficios
                                </li>
                                <li
                                    id="tab-deducibles"
                                    onClick={() => onChangeMenu("deducibles")}
                                    className="color-normal"
                                >
                                    Deducibles
                                </li>

                            </ul>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1">
                            <a
                                href={SeguroHyundai}
                                className="text-reset text-decoration-none"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <FontAwesomeIcon icon={faDownload} />
                                <span className="menu-extra"> Brochure</span>
                            </a>
                        </Col>
                        <Col xs={3} md={1} className="text-center my-auto cont-extra px-1" onClick={() => setShow(true)}>
                            <div
                                style={{ cursor: "pointer" }}
                                className="text-reset text-decoration-none"
                            >
                                <FontAwesomeIcon icon={faCar} />
                                <span className="menu-extra"> Cotizar</span>
                            </div>
                        </Col>
                        <ModalContactoSeguroHyundai
                            setShow={setShow} show={show}
                        >
                        </ModalContactoSeguroHyundai>
                    </Row>
                </Container>
            </div>
            {/***************************************** beneficios ***************************************/}
            <section id="beneficios">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title">Beneficios generales</h2>
                        </Col>
                    </Row>
                    <Row className="ml-2 mr-2">
                        <Col md={6}>
                            <Row className="flexContainer">
                                <div><LazyLoadImage src={beneficioSmallA} alt="beneficioSmallA" className="icon-small" /></div>
                                <div className="icon-text my-auto">
                                    <ul className="my-auto">
                                        <li>Seguro Full Cobertura (Todo Riesgo).</li>
                                    </ul>
                                </div>
                            </Row>
                            <Row className="flexContainer my-auto">
                                <div>
                                    <LazyLoadImage src={beneficioSmallB} alt="beneficioSmallB" className="icon-small" />
                                </div>
                                <div className="icon-text my-auto">
                                    <ul className="my-auto">
                                        <li>Daños Parciales (Daño – Robo) / valor del vehículo.</li>
                                    </ul>
                                </div>
                            </Row>
                            <Row className="flexContainer my-auto">
                                <div>
                                    <LazyLoadImage src={beneficioSmallC} alt="beneficioSmallC" className="icon-small" />
                                </div>
                                <div className="icon-text my-auto">
                                    <ul className="my-auto">
                                        <li>Pérdidas Totales (Daño – Robo) / valor del vehículo.</li>
                                    </ul>
                                </div>
                            </Row>
                            <Row className="flexContainer my-auto">
                                <div>
                                    <LazyLoadImage src={beneficioSmallD} alt="beneficioSmallD" className="icon-small" />
                                </div>
                                <div className="icon-text my-auto">
                                    <ul className="my-auto">
                                        <li>Responsabilidad Civil (Daños a Terceros) hasta $30.000.</li>
                                    </ul>

                                </div>
                            </Row>
                            <Row className="flexContainer my-auto">
                                <div>
                                    <LazyLoadImage src={beneficioSmallE} alt="beneficioSmallE" className="icon-small" />
                                </div>
                                <div className="icon-text my-auto">
                                    <ul className="my-auto">
                                        <li>Accidentes Personales por Ocupante $ 5.000.</li>
                                    </ul>

                                </div>
                            </Row>
                            <Row className="flexContainer my-auto">
                                <div>
                                    <LazyLoadImage src={beneficioSmallF} alt="beneficioSmallF" className="icon-small" />
                                </div>
                                <div className="icon-text my-auto">
                                    <ul className="my-auto">
                                        <li>Gastos Médicos por Ocupante $ 2.500.</li>
                                    </ul>
                                </div>
                            </Row>
                            <Row className="flexContainer my-auto">
                                <div>
                                    <LazyLoadImage src={beneficioSmallG} alt="beneficioSmallG" className="icon-small" />
                                </div>
                                <div className="icon-text my-auto">
                                    <ul className="my-auto">
                                        <li>Cobertura extraterritorial en Colombia y Perú hasta 200 km.</li>
                                    </ul>

                                </div>
                            </Row>
                        </Col>
                        <Col md={6}>
                            <Row className="flexContainer my-auto">
                                <div>
                                    <LazyLoadImage src={beneficioSmallI} alt="beneficioSmallI" className="icon-small" />
                                </div>
                                <div className="icon-text my-auto">
                                    <ul className="my-auto">
                                        <li>Airbags al 100%.</li>
                                    </ul>
                                </div>
                            </Row>
                            <Row className="flexContainer my-auto">
                                <div>
                                    <LazyLoadImage src={beneficioSmallJ} alt="beneficioSmallJ" className="icon-small" />
                                </div>

                                <div className="icon-text my-auto">
                                    <ul className="my-auto">
                                        <li> En caso de siniestros las reparaciones se realizarán en el taller
                                            del concesionario con repuestos genuinos y mano de obra calificada.
                                        </li>
                                    </ul>
                                </div>
                            </Row>
                            <Row className="flexContainer my-auto">
                                <div>
                                    <LazyLoadImage src={beneficioSmallK} alt="beneficioSmallK" className="icon-small" />
                                </div>
                                <div className="icon-text my-auto">
                                    <ul className="my-auto">
                                        <li>Licencia caducada 45 días.</li>
                                    </ul>
                                </div>
                            </Row>
                            <Row className="flexContainer my-auto">
                                <div>
                                    <LazyLoadImage src={beneficioSmallL} alt="beneficioSmallL" className="icon-small" />
                                </div>
                                <div className="icon-text my-auto">
                                    <ul className="my-auto">

                                        <li>Asistencia de grúa por accidente o avería hasta
                                            $ 200 en exceso de lo brindado por asistencia.
                                        </li>
                                    </ul>
                                </div>
                            </Row>
                            <Row className="flexContainer my-auto">
                                <div>
                                    <LazyLoadImage src={beneficioSmallM} alt="beneficioSmallM" className="icon-small" />
                                </div>
                                <div className="icon-text my-auto">
                                    <ul className="my-auto">
                                        <li>Auxilio Mecánico.</li>
                                    </ul>

                                </div>
                            </Row>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="ml-3 ml-md-0 py-3 py-md-5">
                            <Col md={4}>
                                <Row>
                                    <div className="right">
                                        <img src={beneficioA} alt="beneficioA" className="icon-med" />
                                    </div>
                                    <div className="left">
                                        <ul>
                                            <li className="titulo">Grúa</li>
                                            <li className="text-column">Accidente hasta $350 por evento.</li>
                                            <li className="text-column">Avería hasta $300 por evento.</li>
                                            <li className="text-column">Robo parcial hasta $300 por evento.</li>
                                            <li className="text-column">Sin límite de eventos al año.</li>
                                            <li className="text-column">Rescate por maniobra o encunetamiento.</li>
                                            <ul>
                                                <li className="text-column">Hasta $300 por evento</li>
                                                <li className="text-column">2 eventos al año.</li>
                                                <li className="text-column">Grúa de $200 por segundo
                                                    traslado, 2 eventos al año.
                                                </li>
                                            </ul>
                                        </ul>
                                    </div>
                                </Row>
                                <Row className="mt-4">
                                    <div className="right">
                                        <img src={beneficioB} alt="beneficioB" className="icon-med" />
                                    </div>
                                    <div className="left">
                                        <ul>
                                            <li className="titulo">Asistencia legal</li>
                                            <li className="text-column">Asistencia legal y defensa preliminar en
                                                caso de accidente automovilístico, 3
                                                eventos al año.
                                            </li>
                                            <li className="text-column">Abogado hasta el lugar del siniestro para
                                                brindar la asistencia legal, dentro del
                                                perímetro urbano de las ciudades de
                                                Quito, Guayaquil, Cuenca y Ambato.
                                            </li>

                                            <li className="text-column">Asistencia legal telefónica en caso de
                                                matriculación.
                                            </li>
                                            <li className="text-column">Sin límite a nivel nacional.</li>
                                            <li className="text-column">Asistencia legal telefónica en caso de:</li>
                                            <ul>
                                                <li className="text-column">Liberación de vehículo y
                                                    documentos retenidos.
                                                </li>
                                                <li className="text-column">Robo total y/o parcial del
                                                    vehículo afiliado.
                                                </li>
                                                <li className="text-column">Accidente automovilístico.</li>
                                                <li className="text-column">Asesoría en caso de infracción o
                                                    contravención de tránsito.
                                                </li>
                                                <li className="text-column">Consultoría en temas civiles,
                                                    penales y familiares.
                                                </li>
                                            </ul>
                                        </ul>
                                    </div>
                                </Row>
                            </Col>
                            <Col md={4}>
                                <Row>
                                    <div className="right">
                                        <img src={beneficioC} alt="beneficioC" className="icon-med" />
                                    </div>
                                    <div className="left">
                                        <ul>
                                            <li className="titulo">Asistencia vial</li>
                                            <li>Paso de corriente.</li>
                                            <li>Cambio de llanta por repuesto.</li>
                                            <li>Suministro de combustible.</li>
                                            <ul>
                                                <li>Hasta $250 por evento.</li>
                                                <li>Sin límites de eventos al año.</li>
                                            </ul>
                                            <li>Cerrajería vial.</li>
                                            <ul>
                                                <li>Hasta $200 por evento.</li>
                                                <li>Sin límites de eventos al año</li>
                                            </ul>
                                            <li>Conductor elegido.</li>
                                            <ul>
                                                <li>2 horas por evento.</li>
                                                <li>2 eventos al año.</li>
                                            </ul>
                                        </ul>
                                    </div>
                                </Row>
                                <Row className="mt-4">
                                    <div className="right">
                                        <img src={beneficioD} alt="beneficioD" className="icon-med" />
                                    </div>
                                    <div className="left">
                                        <ul>
                                            <li className="titulo">Auto sustituto</li>
                                            <li className="ml-0">En caso de accidente o robo del vehículo
                                                asegurado, si el valor del siniestro es superior
                                                a $1.000 se coordinará, y asumirá los gastos
                                                de vehículo de reemplazo tipo económico.
                                            </li>
                                            <ul>
                                                <li>10 días en caso de pérdidas
                                                    parciales.
                                                </li>
                                                <li>20 días en caso de pérdidas
                                                    totales.
                                                </li>
                                                <li>2 eventos al año, sin límite
                                                    kilométrico de utilización.
                                                </li>
                                                <li>Esta cobertura no contempla la
                                                    garantía bancaría, ni los gastos
                                                    de retiro y entrega del vehículo.
                                                </li>
                                            </ul>
                                        </ul>
                                    </div>
                                </Row>
                            </Col>
                            <Col md={4}>
                                <Row>
                                    <div className="right">
                                        <img src={beneficioE} alt="beneficioE" className="icon-med" />
                                    </div>
                                    <div className="left">
                                        <ul>
                                            <li className="titulo">
                                                Amparo patrimonial
                                            </li>
                                            <li>
                                                Cobertura en caso de siniestros a
                                                consecuencia de desatenciones de tránsito.
                                                (Básico).
                                            </li>
                                        </ul>
                                    </div>
                                </Row>
                                <Row className="mt-3">
                                    <div className="right">
                                        <img src={beneficioF} alt="beneficioF" className="icon-med" />
                                    </div>
                                    <div className="left">
                                        <ul>
                                            <li className="titulo">
                                                Llaves protegidas
                                            </li>
                                            <li>Límite de $300 máximo un evento al año.</li>
                                        </ul>
                                    </div>
                                </Row>
                                <Row className="mt-3">
                                    <div className="right">
                                        <img src={beneficioG} alt="beneficioG" className="icon-med" />
                                    </div>
                                    <div className="left">
                                        <ul>
                                            <li className="titulo">
                                                Documentos protegidos
                                            </li>
                                            <li>Límite de $150 máximo un evento al año.</li>
                                        </ul>
                                    </div>
                                </Row>
                                <Row className="mt-3">
                                    <div className="right">
                                        <img src={beneficioH} alt="beneficioH" className="icon-med" />
                                    </div>
                                    <div className="left">
                                        <ul>
                                            <li className="titulo">
                                                Asistencia in situ
                                            </li>
                                            <li>Ayuda y asesoramiento de un experto en siniestros en el momento de un
                                                accidente.
                                            </li>
                                        </ul>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Container>
                    <div className="my-3">
                        <Col md={12} className="text-center my-auto" >
                            <Button
                                onClick={() => setShow(true)}
                                type="submit"
                                style={{
                                    backgroundColor: '#003669', width: '200px',
                                    fontSize: '21px',
                                    fontFamily: 'HyundaiSansHead-Medium',

                                }}
                            >
                                Cotizar
                                <Image
                                    src={Enviar}
                                    alt="Enviar icono"
                                    className="enviar-icono-seguro"
                                    /*
                                    className="plane ml-2"
                                    fluid
                                    style={{ width: 25 }}*/
                                />
                            </Button>
                        </Col>
                    </div>
                    <Row className="py-3 py-md-5">
                        <Col md={12} className="text-center">
                            <h2 className="galeria-titulo  pb-2">Beneficios únicos</h2>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <Row className="flexContainer my-auto">
                                <div>
                                    <img src={deducibleA} alt="deducibleA" className="icon-med" />
                                </div>
                                <div className="icon-text">
                                    <ul>
                                        <li className="titulo">
                                            Protección neumáticos
                                        </li>
                                        <li>
                                            Hasta el límite de US$ 200,00 en
                                            Agregado Anual.
                                        </li>
                                        <li>(máximo 1 evento al año),
                                            vía reembolso.
                                        </li>
                                    </ul>
                                </div>
                            </Row>
                            <Row className="flexContainer my-auto">
                                <div>
                                    <img src={deducibleB} alt="deducibleB" className="icon-med" />
                                </div>
                                <div className="icon-text">
                                    <ul>
                                        <li className="titulo">
                                            Protección de Mantenimiento
                                        </li>
                                        <li>Diagnóstico total y sanitización
                                            antes y después de un viaje.
                                        </li>
                                        <li>Servicio Car Wash mensual.</li>
                                    </ul>
                                </div>
                            </Row>
                            <Row className="flexContainer my-auto">
                                <div>
                                    <img src={deducibleD} alt="deducibleD" className="icon-med" />
                                </div>
                                <div className="icon-text">
                                    <ul>
                                        <li className="titulo">
                                            Protección Doctor
                                        </li>
                                        <li>Titular + familia.</li>
                                        <li>Orientación médica y psicológica vía telefónica.</li>
                                        <li>Servicio de ambulancia.</li>
                                    </ul>
                                </div>
                            </Row>
                        </Col>
                        <Col md={6} className="mb-5">
                            <Image src={image1} alt="Beneficios"  className="beneficios-seguro" fluid/>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6}></Col>
                            <Col xs={6} md={6} className="text-right">
                                <span
                                    onClick={() => onChangeMenu("deducibles")}
                                    className="titulo-navegacion"
                                >
                                    Deducibles
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className="ml-2 ml-md-3"
                                    />
                                </span>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
            {/***************************************** deducibles ***************************************/}
            <section id="deducibles" className="d-none">
                <Container className="py-4 py-md-5">
                    <Row>
                        <Col md={12} className="text-center">
                            <h2 className="model-title mb-0">Términos y condiciones</h2>
                        </Col>
                    </Row>
                    <Row className="py-3 py-md-5">
                        <Col md={1}>
                            <div className="dedu-icon-box">
                                <img src={deducibleC} alt="deducibleC" className="icon-med" />
                            </div>
                        </Col>
                        <Col md={5}>
                            <div>
                                <ul>
                                    <li className="titulo">Deducibles</li>
                                    <li>10% del valor del siniestro, 1% del valor asegurado mínimo $200.</li>
                                    <li>Pérdida Total por Robo sin dispositivo: 15% del valor asegurado.</li>
                                    <li>Pérdida Total por Robo con dispositivo: 5% del valor asegurado.</li>
                                    <li>Para vehículos que no requieran dispositivo de seguridad se aplicará el
                                        deducible de otros eventos; el que sea mayor.
                                    </li>
                                    <li>Cobertura para neumáticos: sin deducible.</li>
                                    <li>Robo de radios: 10% del valor del radio, no menor a $ 50,00; el que sea
                                        mayor (siempre y cuando no exista daños en el panel).
                                    </li>
                                    <li>Parabrisas: 10% del valor del siniestro, mínimo $ 50,00; el que sea mayor.</li>
                                    <Image src={contactanos} alt="contactanos" fluid/>
                                </ul>
                            </div>
                        </Col>
                        <Col md={6}>
                            <Image className="image-deducibles" src={image2} alt="Deducibles" fluid/>
                        </Col>
                    </Row>
                </Container>
                <div className="bg-landing">
                    <Container>
                        <Row className="py-3 py-md-5">
                            <Col xs={6} md={6} className="text-left">
                                <span
                                    onClick={() => onChangeMenu("beneficios")}
                                    className="titulo-navegacion"
                                >
                                    <FontAwesomeIcon
                                        icon={faChevronLeft}
                                        className="mr-2 mr-md-3"
                                    />
                                    Beneficios
                                </span>
                            </Col>
                            <Col xs={6} md={6} className="text-right">
                            </Col>
                        </Row>
                    </Container>
                </div>
            </section>
        </Fragment>
    );
}
export default InfoSeguroHyundai;